import { environment } from '../../environments/environment';
import { Config } from './config';

const userRolesNameMapping = {
    'Buyer': '1',
    'Salesman': '2'
};


const userRoles = {
    '1': {
        title: 'Buyer',
        readOnly: false,
        url: 'home'
    },
    '2': {
        title: 'Salesman App',
        readOnly: true,
        url: 'home'
    },
    '3': {
        title: 'Buyer Mimic',
        readOnly: true,
        url: 'home'
    }
};

const MenuItems = {
    // home: {
    //     route: '/home',
    //     icon: 'ri-dashboard-line',
    //     linkText: 'LABELS.DASHBOARD',
    //     roles: ['1', '2', '3', '4']
    // },
    paymentsDue: {
        route: '/invoices',
        icon: 'fa fa-file-invoice',
        linkText: 'LABELS.PAYMENT_DUE',
        roles: ['1', '2']
    },
    paymentsHistory: {
        route: '/transactions',
        icon: 'ri-file-history-line',
        linkText: 'LABELS.PAYMENT_HISTORY',
        roles: ['1', '2']
    },
    creditNotes: {
        route: '/creditnotes',
        icon: 'mdi mdi-credit-card-check-outline',
        linkText: 'LABELS.VIEW_CREDIT_NOTES',
        roles: ['1', '2']
    },
    // managecards: {
    //     route: '/manage-payment-methods',
    //     icon: 'mdi mdi-credit-card-multiple-outline',
    //     linkText: 'LABELS.MANAGE_PAYMENT_METHOD',
    //     propToCheck: 'canManagePayMethods',
    //     roles: ['1']
    // },
    manageautopay: {
        route: '/manage-auto-pay',
        icon: 'mdi mdi-credit-card-clock-outline',
        linkText: 'LABELS.MANAGE_AUTO_PAY',
        roles: ['1']
    },
    payAdvance: {
        route: '/payadvance',
        icon: 'ri-secure-payment-line',
        linkText: 'LABELS.PAY_ADVANCE',
        roles: ['1']
    },
    viewStatement: {
        route: '/viewstatement',
        icon: 'ri-file-list-3-line',
        linkText: 'LABELS.VIEW_STATEMENT',
        roles: ['1']
    },
    assigncnsd: {
        route: '/otherforms/assigncnsd',
        icon: 'ri-wallet-3-line',
        propToCheck: 'canAssignSD',
        linkText: 'LABELS.ASSIGN_CN_TO_SECURITY_DEPOSIT',
        roles: ['1']
    },

    salesApproval: {
        route: '/salesapprovalpage',
        icon: 'ri-list-check-2',
        linkText: 'LABELS.REJECTION_APPROVAL',
        roles: ['2']
    },
    viewSapStatement: {
        route: '/otherforms/viewSapStatement',
        icon: 'ri-file-paper-2-line',
        propToCheck: 'companyAccntStmt',
        linkText: 'LABELS.VIEW_COMPANY_ACCOUNT_STATEMENT',
        roles: ['1']
    },
    changePin: {
        route: '/account/changepin',
        icon: 'ri-lock-2-line',
        linkText: 'LABELS.CHANGE_PIN',
        roles: ['1', '2']
    },
    rtrLink: {
        route: '/otherforms/rtrLink',
        icon: 'ri-todo-line',
        // propToCheck: 'reqToRecon',
        linkText: 'LABELS.REQUEST_TO_RECONCILE',
        roles: ['1', '2']
    },
    buyerCompliance: {
        route: '/otherforms/buyerCompliance',
        icon: 'ri-shield-user-line',
        linkText: 'Buyer Compliance',
        roles: ['1', '2']
    },
    contactUs: {
        route: '/contactus',
        fn: 'contactUs',
        icon: 'ri-contacts-book-line',
        linkText: 'LABELS.CONTACT_US',
        roles: ['1', '2']
    },
    help: {
        route: '/help',
        fn: 'openHelp',
        icon: 'fa fa-hands-helping',
        linkText: 'LABELS.HELP',
        roles: ['1', '2']
    },
    creditScore: {
        route: '/account/credit-score',
        icon: 'ri-bar-chart-line',
        linkText: 'My Credit Score',
        roles: ['1']
    },
    exploreFinancing: {
        route: '/explore-financing',
        icon: 'ri-bank-line',
        linkText: 'Explore Financing',
        roles: ['1']
    },
    logout: {
        route: '/signin',
        fn: 'logout',
        icon: 'ri-logout-box-line',
        linkText: 'LABELS.LOG_OUT',
    }
};

const AppMenuItems = {
    Freepay: ['home', 'paymentsDue', 'paymentsHistory', 'transactionsChecker', 'multipayWithDeductions', 'creditNotes', 'managecards', 'manageautopay', 'viewStatement', 'viewSapStatement', 'salesApproval',
        'deferment', 'defermentbyday', 'registerIbp', 'payAdvance', 'enach', 'assignLob', 'helpandsupport', 'assigncnsd', 'rtrLink', 'buyerCompliance', 'creditScore', 'exploreFinancing', 'changePin', 'refreshCashDiscount', 'contactUs', 'help', 'logout'],
    OfflineInsurance: ['paymentsDue', 'paymentsHistory', 'creditNotes', 'raiseClaim', 'claimsManage',
        'deferment', 'defermentManage', 'payAdvance', 'contactUs', 'logout'],
    FreepaySM: ['paymentsDue', 'paymentsHistory', 'creditNotes', 'logout'],
    FreepayRetailerMimic: ['paymentsDue', 'paymentsHistory', 'transactionsChecker', 'multipayWithDeductions', 'creditNotes', 'viewStatement', 'viewSapStatement',
        'deferment', 'payAdvance', 'registerIbp', 'assignLob', 'helpandsupport', 'changePin', 'refreshCashDiscount', 'contactUs', 'help', 'logout'],
    // JPM tenant — restricted menu (keyed by the lowercase tenant from ?app=jpm)
    jpm: ['paymentsDue', 'paymentsHistory', 'creditNotes', 'viewStatement', 'payAdvance', 'rtrLink', 'changePin', 'contactUs', 'help', 'logout']
};

const baseUrl = (environment.API[environment.appName] || environment.API['Freepay'])['url'];
const DataURLs = {
    Freepay: {
        root: `${environment.getRoot}`,
        base: `${baseUrl}`,
        authUrl: `${baseUrl}/auth_ret`,
        invoiceUrl: `${baseUrl}/ret_invoices`,
        dataUrl: `${baseUrl}/invoice_data`,
        statement: `${baseUrl}/stm_ret`,
        khata_statement: `${baseUrl}/retKhata`,
        settings: `${baseUrl}/appsettings`,
        resources: `${baseUrl}/resources?img=`,
        utils: `${baseUrl}/utils`,
    },
    FreepaySM: {
        root: `${environment.getRoot}`,
        base: `${baseUrl}`,
        authUrl: `${baseUrl}/auth_dist`,
        invoiceUrl: `${baseUrl}/invoice_dist`,
        dataUrl: `${baseUrl}/invoice_data`,
        statement: `${baseUrl}/stmt_ret`,
        settings: `${baseUrl}/appsettings`,
        resources: `${baseUrl}/resources?img=`,
    }
};
//TODO: This will be changed to be dynamic based on the environment deployed to
const baseURLForCurrentWindow = `${location.origin}${location.pathname}`;
const langAssetsUrl = `/assets/lang-assets/`;
export const multiLanguageServerURL = `${langAssetsUrl}config/lang-config.json`;
export const dynamicDataTranslationURL = `${langAssetsUrl}config/dynamic-data-labels.json`;
const dataUrls = DataURLs[environment.appName] || DataURLs.Freepay;

enum appEvents {
    CLOSE_ALL_DIALOGS = 'close_all_dialogs'
}

const appThemeConfig = {
    'payex': {
        title: 'PayEX App',
        logo: 'assets/images/payex-logo.png',
        logo1: 'assets/images/payex-logo-v2.png',
        loginBg: 'assets/images/bg-auth.jpg',
        favIcon: 'assets/img/payex_1.png',
        cssFile: '',
        heroBadge: 'Buyer Portal',
        heroTitle: 'AI-Driven AP and AR<br>Automation Software',
        heroTagline: 'Working capital efficiencies via AR and AP automation. Buyer-seller collaboration, AI/ML tech, automated ERP accounting and more.',
        showCarousel: true
    },
    'bmo': {
        title: 'BMO - Buyer Portal',
        logo: 'assets/seller-theme/bmo/bmo-logo.svg',
        logo1: 'assets/seller-theme/bmo/bmo-logo.svg',
        loginBg: 'assets/seller-theme/bmo/bmo_auth.jpg',
        favIcon: 'assets/seller-theme/bmo/bmo-favicon.png',
        cssFile: 'assets/css/bmo-theme.css',
        heroBadge: 'Welcome to Dashboard',
        heroTitle: '',
        heroTagline: 'Get rewards for paying early! Accept early payment discount to claim a discount on your total of credit based services.',
        showCarousel: false
    },
    'transworld': {
        title: 'TransPay App',
        logo: 'assets/seller-theme/transworld/logo.png',
        logo1: 'assets/seller-theme/transworld/logo.png',
        loginBg: 'assets/seller-theme/transworld/logo.png',
        favIcon: 'assets/seller-theme/transworld/logo.png',
        cssFile: '',
        heroBadge: 'Buyer Portal',
        heroTitle: 'AI-Driven AP and AR<br>Automation Software',
        heroTagline: 'Working capital efficiencies via AR and AP automation. Buyer-seller collaboration, AI/ML tech, automated ERP accounting and more.',
        showCarousel: true
    },
    'fispay': {
        title: 'FISPay - Buyer Portal',
        logo: 'assets/seller-theme/fis/fis_logo2.png',
        logo1: 'assets/seller-theme/fis/fis_logo2.png',
        loginBg: 'assets/seller-theme/fis/fis_logo2.png',
        favIcon: 'assets/seller-theme/fis/fis_favicon.png',
        cssFile: '',
        heroBadge: 'Buyer Portal',
        heroTitle: 'AI-Driven AP and AR<br>Automation Software',
        heroTagline: 'Working capital efficiencies via AR and AP automation. Buyer-seller collaboration, AI/ML tech, automated ERP accounting and more.',
        showCarousel: true
    },
    // JPM tenant. Using PayEX assets as placeholders until JPM-specific
    // logo/css are provided; menu is restricted via AppMenuItems['jpm'].
    'jpm': {
        title: 'JPM - Buyer Portal',
        logo: 'assets/images/payex-logo.png',
        logo1: 'assets/images/payex-logo-v2.png',
        loginBg: 'assets/images/bg-auth.jpg',
        favIcon: 'assets/img/app_favicon.png',
        cssFile: '',
        heroBadge: 'Buyer Portal',
        heroTitle: 'AI-Driven AP and AR<br>Automation Software',
        heroTagline: 'Working capital efficiencies via AR and AP automation. Buyer-seller collaboration, AI/ML tech, automated ERP accounting and more.',
        showCarousel: true
    }
};

export const APPCONFIG = {
    base: environment.base,
    root: baseUrl,
    imgUrl: baseUrl,
    urls: {
        root: `${environment.getRoot}`,
        base: dataUrls.base,
        authUrl: dataUrls.authUrl,
        invoiceUrl: dataUrls.invoiceUrl,
        dataurl: dataUrls.dataUrl,
        statement: dataUrls.statement,
        settings: dataUrls.settings,
        resources: dataUrls.resources,
        khata_statement: dataUrls.khata_statement,
        auto_update: `${environment.base}/FreepayNG/config/update.json`,
        utils: dataUrls.utils,
        uploadCourierReceipt: `${dataUrls.invoiceUrl}/uploadMtlsCc`,
        uploadRejectionFile : `${dataUrls.invoiceUrl}/dashboard/ledgerDocUpload`,
        enachUrl: `${dataUrls.invoiceUrl}`,
        langAssetsUrl: `${langAssetsUrl}i18n/`,
        nodeAPIUrl: `${environment.nodeAPIUrl}`,
        dynamicDataTranslationURL,
        logoBaseUrl: environment.environmentConfig.LOGO_BASE_URL
    },
    appName: environment.appName,
    menuItems: MenuItems,
    appMenuItems: AppMenuItems,
    appVersion: '1.9.0',
    deployDate: '2026.06.11_A',
    environment_name: environment.environment_name,
    web_api_version: environment.web_api_version,
    appEvents: appEvents,
    defaultImage: Config.defaultImage,
    webActions: Config.webActions,
    userRoles,
    userRolesNameMapping,
    appThemeConfig,
    baseURLForCurrentWindow
};
